import { isMobileScreen } from '@apply/ui';
import { FinishedButtonPanel } from './components/FinishedButtonPanel/FinishedButtonPanel';

export const FinishedPanel = () => {
    const mobileScreen = isMobileScreen();

    return (
        <>
            <div style={{ textAlign: 'center' }}>
                <h3>Your payment has succeeded.</h3>
                <p role='alert'>Thank you!</p>
            </div>
            <FinishedButtonPanel />
        </>
    );
};
